export default __webpack_public_path__ + "static/media/Pensive.e70673c2.svg";